export default __webpack_public_path__ + "static/media/__quickcam_banner_text.b96a9314.svg";